import React from 'react';
import { Button, Col, Modal, Row } from 'antd';
import FeatherIcon from 'feather-icons-react';
import { FieldArray, Formik, Form } from 'formik';
//
import { electricityPriceSchema } from './electricity-price.schema';
import { BasicFormWrapper } from '../styled';
import FormInput from '../../components/input/input';
//

const CreateElectricityModal = ({ visible, onCancel, handleSubmit }) => {
  const handleElectricityItemChange = (fieldElectricityPrices, setFieldValues, index, value, key) => {
    const temp = [...fieldElectricityPrices];
    if (!temp[index]) return;
    const currentItem = JSON.parse(JSON.stringify(temp[index]));
    currentItem[key] = value;
    temp[index] = currentItem;
    setFieldValues('timeBasedPrices', temp);
  };
  return (
    <Modal type="primary" title="Create Electricity Price" footer={null} onCancel={onCancel} visible={visible}>
      <div className="brand-modal">
        <Formik
          validationSchema={electricityPriceSchema}
          initialValues={{
            effectiveDate: '',
            timeBasedPrices: [
              {
                timing: '',
                price: 0,
              },
            ],
          }}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            setSubmitting(false);
            handleSubmit(values, resetForm);
          }}
        >
          {({ values, errors, touched, handleChange, setFieldValue, resetForm }) => {
            return (
              <Form>
                <BasicFormWrapper>
                  <div className="add-product-block">
                    <Col xs={24}>
                      <FormInput
                        type="date"
                        name="effectiveDate"
                        label="Effective Date"
                        value={values.effectiveDate}
                        handleChange={handleChange}
                        errors={errors}
                        touched={touched}
                      />
                    </Col>
                    <Col xs={24}>
                      <div style={{ maxHeight: '400px', overflowY: 'auto', overflowX: 'hidden' }}>
                        <FieldArray
                          name="timeBasedPrices"
                          render={arrayHelper => {
                            return (
                              <Row gutter={[0, 8]} style={{ marginTop: '16px' }}>
                                <Col xs={24}>
                                  <Row>
                                    <Col xs={10} className="input-required">
                                      <div style={{ fontWeight: 500, color: 'rgba(0, 0, 0, 0.85)' }}>
                                        Timing / Tariff
                                      </div>
                                    </Col>
                                    <Col xs={10} className="input-required">
                                      <div style={{ fontWeight: 500, color: 'rgba(0, 0, 0, 0.85)' }}>
                                        Electricity Price (Per kWh)
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                                {values.timeBasedPrices.map((price, index) => (
                                  <Col xs={24} key={`${index}-${price.id}`}>
                                    <Row gutter={[4, 0]}>
                                      <Col xs={10}>
                                        <FormInput
                                          name={`timeBasedPrices.${index}.timing`}
                                          isRequired={false}
                                          value={price.timing}
                                          errors={errors}
                                          touched={touched}
                                          placeholder="Please Enter Electricity Timing"
                                          onChange={event =>
                                            handleElectricityItemChange(
                                              values.timeBasedPrices,
                                              setFieldValue,
                                              index,
                                              event.target.value,
                                              'timing',
                                            )
                                          }
                                        />
                                      </Col>
                                      <Col xs={10}>
                                        <FormInput
                                          name={`price.${index}.price`}
                                          type="number"
                                          isRequired={false}
                                          value={price.inlandPrice}
                                          errors={errors}
                                          touched={touched}
                                          placeholder="Please Enter Electricity Price"
                                          onChange={event =>
                                            handleElectricityItemChange(
                                              values.timeBasedPrices,
                                              setFieldValue,
                                              index,
                                              event.target.value,
                                              'price',
                                            )
                                          }
                                        />
                                      </Col>
                                      <Col xs={2} style={{ display: 'flex', alignItems: 'end' }}>
                                        <Button
                                          disabled={values.timeBasedPrices.length === 1}
                                          style={{ margin: '4px' }}
                                          onClick={() => arrayHelper.remove(index)}
                                          shape="circle"
                                          icon={<FeatherIcon icon="minus-circle" size={10} />}
                                        />
                                      </Col>
                                      <Col xs={2} style={{ display: 'flex', alignItems: 'end' }}>
                                        {index === values.timeBasedPrices.length - 1 && (
                                          <Button
                                            style={{ margin: '4px' }}
                                            onClick={() => arrayHelper.push({ timing: '', price: 0 })}
                                            shape="circle"
                                            icon={<FeatherIcon icon="plus-circle" size={10} />}
                                          />
                                        )}
                                      </Col>
                                    </Row>
                                  </Col>
                                ))}
                              </Row>
                            );
                          }}
                        />
                      </div>
                    </Col>
                    <div style={{ height: '16px' }} />
                    <Col xs={24}>
                      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                          style={{
                            backgroundColor: '#155BDC',
                            color: '#fff',
                            marginRight: 5,
                            height: '40px',
                            fontWeight: '500',
                          }}
                          htmlType="submit"
                        >
                          Add Electricity Price
                        </Button>
                        <Button
                          size="default"
                          type="white"
                          style={{
                            marginRight: 5,
                            height: '40px',
                            fontWeight: '500',
                          }}
                          key="back"
                          outlined="true"
                          onClick={() => {
                            resetForm();
                            onCancel();
                          }}
                        >
                          Reset
                        </Button>
                      </div>
                    </Col>
                  </div>
                </BasicFormWrapper>
              </Form>
            );
          }}
        </Formik>
      </div>
    </Modal>
  );
};

export default CreateElectricityModal;
